import {useApi} from "../Api";
import {
    FormSearchOWLocationGroupLocationModel,
    LocatonGroupLocationReplacementRequest,
    OWLocationGroupLocation,
    OWLocationGroupLocations
} from "../types/owLocationGroupLocation";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";

export const useOWLocationGroupLocationRepository = () => {
    const {GET, POST} = useApi();

    const PATH = "/pricing/ow-location-group-location";

    function putOWLocationGroupLocation(owLocationGroupLocations: LocatonGroupLocationReplacementRequest[]): Promise<OWLocationGroupLocation[]> {
        return POST(`${PATH}/replace-associations`, owLocationGroupLocations);
    }

    function getOWLocationGroupLocationsPaged(filters: FormSearchOWLocationGroupLocationModel): Promise<PagedResponse<OWLocationGroupLocations>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }


    return {
        putOWLocationGroupLocation,
        getOWLocationGroupLocationsPaged
    };
};